import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's102g-s102m01',
    templateUrl: './s102g-s102m01.component.html'
})
export class S102gS102m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    hdrtag: any = {};
    line01: any = {};
    line02: any = {};
    line03: any = {};
    line04: any = {};
    line05: any = {};
    line06: any = {};
    line07: any = {};
    line08: any = {};
    line09: any = {};
    line10: any = {};
    line11: any = {};
    line12: any = {};
    line13: any = {};
    line14: any = {};
    line15: any = {};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'hdrtag', 'line01', 'line02', 'line03', 'line04', 'line05', 'line06', 'line07', 'line08', 'line09', 'line10', 'line11', 'line12', 'line13', 'line14', 'line15', 'msgln'];
    public LINES: number[] = [1, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

    ngAfterViewInit(): void {
    }
}
